<template>
  <div class="content" id='qa'>
    <h2 class="m-n">提携サービス</h2>
    <div class="row m-t-md">
      <template v-for="item in pageData">
        <router-link :key="item.groupId" :to="{ name: 'External Service Detail', params: { id: item.id, item: item }}">
          <div class="katal kat-tile-grid" >
            <div class="kat-tile-grid-container">
              <div class="kat-tile">
                <div v-tooltip.right="item.short_description" class="tile-image-container">
                  <img
                    :src="item.image"
                    width="208px"
                    height="220px"
                  />
                  <h4>
                    <span class="service_name">{{ item.name }}</span>
                  </h4>
                  <p class="company_name">
                    {{ item.company_name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </router-link>
      </template>
    </div>
    <div>
      <pagination
        :url="'ExternalService/list'"
        @onChangePage="onChangePage"
      />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      pageData: []
    }
  },
  components: {
    Pagination
  },
  methods: {
    /*
     * Handle on page change
     *
     * @param {Array} data Data from API
     *
     * @return void
     */
    onChangePage (data) {
      this.pageData = [...data]
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.external_services.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  }
}
</script>

<style scoped>
.katal {
  position: relative;
  display: grid;
  grid-template-columns: repeat(auto-fill,minmax(260px,1fr));
  grid-gap: 20px;
  justify-content: space-around;
  float: left;
}

.kat-tile-grid {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}

.kat-tile-grid-container {
  margin: 0;
  display: flex;
  justify-content: center;
}

.kat-tile {
  background-image: linear-gradient(-180deg ,#fff,#fafafa);
  border: 1px solid #e3eced;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: 15px;
  width: 260px;
  height: 350px;
  display: flex;
  overflow: hidden;
}

.service_name {
  color: #008cc6;
}

.company_name {
  color: #373d3e;
}

.tile-image-container {
  display: table-cell;
  vertical-align: middle;
  width: 220px;
  cursor: pointer;
}

.kat-tile img {
  display: block;
  max-width: 220px;
  padding-bottom: .75rem;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/view/externalServices/ExternalServices.vue